<div class="coming-soon">
  <app-header *ngIf="standaloneLayout" [forceLightBackground]="true"></app-header>
  
  <main class="coming-soon--main">
    <div class="coming-soon--container">
      <div class="coming-soon--content">
        <h1 class="coming-soon--title">{{ pageTitle }}</h1>
        <p class="coming-soon--message">{{ pageMessage }}</p>
      </div>
      
      <!-- Notify Me Section -->
      <div class="coming-soon--cta">
        <p class="coming-soon--cta-text">
          Stay tuned for updates. Sign up to be notified when this page launches.
        </p>
        <button class="coming-soon--notify-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Notify Me
        </button>
      </div>
    </div>
  </main>
  
  <app-footer *ngIf="standaloneLayout"></app-footer>
</div>
